import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class AcompanhamentoApi {
  cancelTokens = {
    getAcompanhamentos: null,
    getAcompanhamento: null,
    setAcompanhamento: null,
    destroyAcompanhamento: null,
    getDadosRhNet: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }
  
  // # Atualizado com os parâmetros exatos da nossa tela de pesquisa e Scopes do Rails
  async getAcompanhamentos({ 
    page = 1, 
    qtd_por_pagina, 
    nome,
    cpf,
    processo_sei,
    colegiado_id,
    conselho_id,
    tipo_movimentacao,
    status,
    acompanhando,
    concluido,
    ordenar_por,
    ordem
  }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      nome,
      cpf,
      processo_sei,
      colegiado_id,
      conselho_id,
      tipo_movimentacao,
      status,
      acompanhando,
      concluido,
      ordenar_por,
      ordem      
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getAcompanhamentos = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getAcompanhamentos = null;
    return data;
  }

  // --- INTEGRAÇÃO SEI ---
  async getProcedimentoSei(numeroProcessoSei) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    
    // Adicione a variável getProcedimentoSei no cancelTokens lá no topo do arquivo se quiser manter o padrão
    const { data } = await axiosInstance.post(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/consultar_procedimento_sei`,
      { numeroProcessoSei: numeroProcessoSei },
      { cancelToken: source.token }
    );
    return data;
  }

// Busca os Órgãos do SGU
  async getOrgaosOrigem(){
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/colegiados/orgao_origem`,
      { cancelToken: source.token }
    );
    return data; 
  }

  async getAndamentosSei(numeroProcessoSei) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    
    const { data } = await axiosInstance.post(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/listar_andamentos_sei`,
      { numeroProcessoSei: numeroProcessoSei },
      { cancelToken: source.token }
    );
    return data;
  }

  async consultarCpfReceita(cpf) {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/buscar_dados_receita.json?cpf=${cpf}`
    );
    
    // Transforma para maiúsculo para manter o padrão visual dos nomes
    if (data && data.nome) data.nome = data.nome.toUpperCase(); 
    return data;
  }

  async getDadosRhNet(cpf) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // Garante que não haja várias requisições encavaladas se a pessoa digitar rápido
    this.cancelTokens.getDadosRhNet = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/buscar_dados_rh_net.json?cpf=${cpf}`,
      {
        cancelToken: source.token,
      }
    );

    // Já transforma o nome para maiúsculo para manter o padrão visual
    if (data && data.nome) data.nome = data.nome.toUpperCase();

    this.cancelTokens.getDadosRhNet = null;
    return data;
  }

  async getAcompanhamento(acompanhamentoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getAcompanhamento = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/${acompanhamentoId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getAcompanhamento = null;
    return data;
  }

  // Busca os Colegiados Reais filtrados por Órgão
  async getColegiados(orgaoId = null){
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.getOrgao = source;

    let url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/colegiados?qtd_por_pagina=1000`;
    
    if (orgaoId) {
      url += `&orgao_id=${orgaoId}`;
    }

    const { data } = await axiosInstance.get(url, { cancelToken: source.token });

    this.cancelTokens.getOrgao = null;
    return data.colegiados; 
  }

  // Busca os Categorias Reais
  async getCategorias(){
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/categorias_representativas?qtd_por_pagina=1000`,
      { cancelToken: source.token }
    );
    return data; 
  }

  async getCargos(){
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/cargos_colegiados?qtd_por_pagina=1000`,
      { cancelToken: source.token }
    );
    return data; 
  }

  async destroyAcompanhamento(acompanhamentoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyAcompanhamento = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/${acompanhamentoId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyAcompanhamento = null;
    return data;
  }
  
  async setAcompanhamento(acompanhamento) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
  
    this.cancelTokens.setAcompanhamento = source;

    if (!acompanhamento.id) {
      delete acompanhamento.id;
    }

    // Envolvendo o payload dentro do objeto 'acompanhamento' para casar com o strong parameters do Rails
    const payload = {
      acompanhamento: acompanhamento
    };
  
    if (acompanhamento.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/${acompanhamento.id}`,
        payload,
        {
          cancelToken: source.token,
        }
      );

      this.cancelTokens.setAcompanhamento = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos`,
        payload,
        {
          cancelToken: source.token,
        }
      );

      this.cancelTokens.setAcompanhamento = null;
      return data;
    }
  }

  async atualizarStatusConclusao(acompanhamentoId, concluido) {
    const { data } = await axiosInstance.patch(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/acompanhamentos/${acompanhamentoId}`,
      { acompanhamento: { concluido } }
    );

    return data;
  }
}

export default AcompanhamentoApi;